var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-google-autocomplete',{ref:"address",attrs:{"id":"map","classname":"form-control","placeholder":_vm.placeholder},on:{"placechanged":_vm.onAddressChange}})}
var staticRenderFns = []

export { render, staticRenderFns }